import React from 'react';
import { useTranslation } from 'react-i18next';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import Select from '@/components/common/Select/Select';
import { IGenre } from '@/data/models/genre';
import { IOptions } from '@/data/models/option';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  genres: IOptions<IGenre>[];
  loadGenres: (inputText: string | null, callback: any) => void;
  handleGenre: (selectedOption: IGenre) => void;
};

export default function GenreFormGroup({
  album,
  disabled,
  readonly,
  genres,
  loadGenres,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleGenre,
}: Props) {
  const { t } = useTranslation();

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.product.genre"
      hasErrors={
        fieldHasErrors('Genre') ||
        (showValidationErrors && !album.albumMetaData?.genre)
      }
    >
      {genres.length > 0 && (
        <Select
          id="genre"
          labelTitle={t('product.editProduct.genre')}
          labelClass="col-sm-3 form-label"
          isClearable
          loadOptions={loadGenres}
          placeholder=""
          data-testid="genre-select"
          onChange={(e: any) => handleGenre(e?.value)}
          initialOption={genres.find(
            (g) => g.value.id === album.albumMetaData?.genre?.id
          )}
          className="col-sm-6"
          isDisabled={disabled}
          isReadOnly={readonly}
          hasErrors={fieldHasErrors('Genre')}
          errorMessage={findErrorMessage('Genre')}
          isRequired={true}
          showValidationErrors={showValidationErrors}
          fieldValidationKey={'productEditMode.Genre'}
        />
      )}
    </FormGroupWithTooltip>
  );
}
